import {
  FormControlLabel,
  FormGroup,
  InputLabel,
  TableBody,
  TextField,
  Typography
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import VisaIssuanceSection from "components/request-document/components/VisaIssuanceSection";
import { useFormik } from "formik";
import {
  REQUEST_DOCUMENT_STEP,
  RoleId,
  STATUS_PROCESS
} from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData } from "redux/modules/masterSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormFieldConfig
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function UserProfileStepC() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const draftId = useSelector(selectDraftId);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);
  const canEdit = useSelector(canEditForm);
  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });

  const personalId = get(personalDetail, "personalID", "");

  const detailList = [
    "EmployerInThai",
    "JobPosition",
    "WorkAddress",
    "PhoneNumber",
    "Email",
    "JobDescription",
    "NameOfReference",
    "Position",
    "EmailReference",
    "MobilePhone",
    "HaveDetailInThai",
  ];

  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const partfromId =
    defaultType.find((field) => field.partFromName === "Part B")?.partfromId ||
    "";
  const detail = get(smartform, "detail", [])
    .filter((field) => field.partfromId === partfromId)
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  useEffect(() => {
    dispatch(
      getMasterData({
        CountryConfig: true,
        countryEmbassy: true,
        CityConfig: true,
        VisaTypeConfig: true,
        theImmigrationBureauConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    addSmartFormState,
    dispatch,
    draftId,
    hideLoading,
    isSaveDraft,
    personalId,
    smartServiceId,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const { visaissuance, ...restValues } = values;

    const documentFields = Object.keys(restValues);
    const getFieldListConfig = defaultType
      .filter((field) => field.partfromId === partfromId)
      .filter((field) => documentFields.includes(field.smartName));

    const getValue = (field) => {
      switch (field.smartName) {
        default:
          return get(values, `${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null,
      visaissuance: visaissuance,
      detail: getFieldListConfig.map((field) => ({
        smartName: field.smartName,
        smartId: getSmartId(field),
        partfromId: field.partfromId,
        configsmartId: field.configsmartId,
        linkTable: field.linkTable,
        value: getValue(field),
      })),
    };

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const validationSchema = yup.object({
    EmailReference: yup.string().email(),
    Email: yup.string().when("HaveDetailInThai", {
      is: true,
      then: yup.string().email().required("E-mail address is required"),
      otherwise: yup.string().email(),
    }),
    EmployerInThai: yup.string().when("HaveDetailInThai", {
      is: true,
      then: yup
        .string()
        .required("Employer or education institution is required"),
      otherwise: yup.string(),
    }),
    JobPosition: yup.string().when("HaveDetailInThai", {
      is: true,
      then: yup.string().required("Job position is required"),
      otherwise: yup.string(),
    }),
    PhoneNumber: yup.string().when("HaveDetailInThai", {
      is: true,
      then: yup.string().required("Phone number is required"),
      otherwise: yup.string(),
    }),
    visaissuance: yup.object().shape({
      countryId: yup.string().when("overseas", {
        is: true,
        then: yup.string().nullable().required("Country is required"),
        otherwise: yup.string().nullable(),
      }),
      cityId: yup.string().when("overseas", {
        is: true,
        then: yup.string().nullable().required("City is required"),
        otherwise: yup.string().nullable(),
      }),
      theImmigrationBureauID: yup.string().when("thailand", {
        is: true,
        then: yup
          .string()
          .nullable()
          .required("The Immigration bureau is required"),
        otherwise: yup.string().nullable(),
      }),
      // visaTypeId: yup.string().nullable().required("VisaType is required"),
      // visaExp: yup.string().nullable().required("Expiry date is required"),
    }),
  });

  const HaveDetailInThai =
    get(detail, "EmployerInThai.value", "") ||
    get(detail, "JobPosition.value", "") ||
    get(detail, "WorkAddress.value", "") ||
    get(detail, "PhoneNumber.value", "") ||
    get(detail, "Email.value", "") ||
    get(detail, "JobDescription.value", "") ||
    get(detail, "NameOfReference.value", "") ||
    get(detail, "Position.value", "") ||
    get(detail, "EmailReference.value", "") ||
    get(detail, "MobilePhone.value", "");

  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: isDraftDocument ? validationSchema : yup.object({}),
    initialValues: {
      HaveDetailInThai: get(
        detail,
        "HaveDetailInThai.value",
        !!HaveDetailInThai
      ),
      EmployerInThai: get(detail, "EmployerInThai.value", ""),
      JobPosition: get(detail, "JobPosition.value", ""),
      WorkAddress: get(detail, "WorkAddress.value", ""),
      PhoneNumber: get(detail, "PhoneNumber.value", ""),
      Email: get(detail, "Email.value", ""),
      JobDescription: get(detail, "JobDescription.value", ""),
      NameOfReference: get(detail, "NameOfReference.value", ""),
      Position: get(detail, "Position.value", ""),
      EmailReference: get(detail, "EmailReference.value", ""),
      MobilePhone: get(detail, "MobilePhone.value", ""),
      visaissuance: {
        visaInssuanceId: get(smartform, "visaissuance.visaInssuanceId", null),
        overseas: get(smartform, "visaissuance.overseas", true),
        countryId: get(smartform, "visaissuance.countryId", ""),
        cityId: get(smartform, "visaissuance.cityId", ""),
        thailand: get(smartform, "visaissuance.thailand", false),
        theImmigrationBureauID: get(
          smartform,
          "visaissuance.theImmigrationBureauID",
          null
        ),
        oneStopService: get(smartform, "visaissuance.oneStopService", false),
        eec: get(smartform, "visaissuance.eec", false),
        visaTypeId: get(smartform, "visaissuance.visaTypeId", ""),
        visaExp: get(smartform, "visaissuance.visaExp", ""),
      },
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });

  // Disabled all field if status != draft
  if (!isDraftDocument && Role !== RoleId.Admin) {
    formik.handleBlur = () => {};
    formik.handleChange = () => {};
    formik.setFieldValue = () => {};
  }

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “O”"
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    {`Part B : Details of applicant's work or study in Thailand`}
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        {`Do you work or study in Thailand ?`}
                      </InputLabel>
                      <FormGroup row style={{ marginTop: 8 }}>
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="HaveDetailInThai"
                              value={formik.values.HaveDetailInThai}
                              checked={Boolean(formik.values.HaveDetailInThai)}
                              onClick={() => {
                                formik.setFieldValue("HaveDetailInThai", true);
                              }}
                            />
                          }
                          label="Yes, I do."
                        />
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="HaveDetailInThai"
                              value={formik.values.HaveDetailInThai}
                              checked={formik.values.HaveDetailInThai === false}
                              onClick={() => {
                                formik.setFieldValue("HaveDetailInThai", false);
                              }}
                            />
                          }
                          label="No, I do not."
                        />
                      </FormGroup>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Employer or education institution in Thailand
                      </InputLabel>
                      <TextField
                        disabled={!formik.values.HaveDetailInThai || !canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="EmployerInThai"
                        value={formik.values.EmployerInThai}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("EmployerInThai", formik)}
                        helperText={getErrorMessage("EmployerInThai", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <div className={classes.wrapField}>
                      <InputLabel>Job position or education level</InputLabel>
                      <TextField
                        disabled={!formik.values.HaveDetailInThai || !canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="JobPosition"
                        value={formik.values.JobPosition}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("JobPosition", formik)}
                        helperText={getErrorMessage("JobPosition", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3} rowSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={3} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Work address or education institution address
                      </InputLabel>
                      <TextField
                        disabled={!formik.values.HaveDetailInThai || !canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="WorkAddress"
                        value={formik.values.WorkAddress}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("WorkAddress", formik)}
                        helperText={getErrorMessage("WorkAddress", formik)}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={4} />
                    <div className={classes.wrapField}>
                      <InputLabel>Phone number</InputLabel>
                      <TextField
                        disabled={!formik.values.HaveDetailInThai || !canEdit}
                        variant="outlined"
                        // type="number"
                        className={classes.textField}
                        name="PhoneNumber"
                        inputProps={{ maxLength: 10 }}
                        onKeyDown={(e) => {
                          const pattern = /[^0-9]/g;
                          const isNotAllow =
                            e.key.length === 1 && pattern.test(e.key);

                          if (isNotAllow) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.PhoneNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("PhoneNumber", formik)}
                        helperText={getErrorMessage("PhoneNumber", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={5} />
                    <div className={classes.wrapField}>
                      <InputLabel>E-mail Address</InputLabel>
                      <TextField
                        disabled={!formik.values.HaveDetailInThai || !canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="Email"
                        value={formik.values.Email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Email", formik)}
                        helperText={getErrorMessage("Email", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={4}>
                  <div className={classes.cellContent}>
                    <Bagde number={6} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Job description (Please fill in this part (No.6 - No.7)
                        if an applicant works in Thailand.)
                      </InputLabel>
                      <TextField
                        disabled={!formik.values.HaveDetailInThai || !canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="JobDescription"
                        value={formik.values.JobDescription}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("JobDescription", formik)}
                        helperText={getErrorMessage("JobDescription", formik)}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={7} />
                    <div className={classes.wrapField}>
                      <InputLabel>{`A reference person's name`}</InputLabel>
                      <TextField
                        disabled={!formik.values.HaveDetailInThai || !canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="NameOfReference"
                        value={formik.values.NameOfReference}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("NameOfReference", formik)}
                        helperText={getErrorMessage("NameOfReference", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>{`A reference person's job title`}</InputLabel>
                      <TextField
                        disabled={!formik.values.HaveDetailInThai || !canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="Position"
                        value={formik.values.Position}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Position", formik)}
                        helperText={getErrorMessage("Position", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>{`E-mail address`}</InputLabel>
                      <TextField
                        disabled={!formik.values.HaveDetailInThai || !canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="EmailReference"
                        value={formik.values.EmailReference}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("EmailReference", formik)}
                        helperText={getErrorMessage("EmailReference", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>{`Mobile phone number`}</InputLabel>
                      <TextField
                        disabled={!formik.values.HaveDetailInThai || !canEdit}
                        variant="outlined"
                        // type="number"
                        className={classes.textField}
                        name="MobilePhone"
                        inputProps={{ maxLength: 10 }}
                        onKeyDown={(e) => {
                          const pattern = /[^0-9]/g;
                          const isNotAllow =
                            e.key.length === 1 && pattern.test(e.key);

                          if (isNotAllow) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.MobilePhone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("MobilePhone", formik)}
                        helperText={getErrorMessage("MobilePhone", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>

            {/* <TableBody>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <Typography variant="h6" className={classes.tableTitle}>
                        Note: Supplementary sheets may be attached if additional
                        space is required
                      </Typography>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody> */}

            <VisaIssuanceSection colSpan={4} formik={formik} />
          </Table>
        </TableContainer>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            padding: "21px 50px",
          }}
        >
          <b>
            I hereby certify that the information and the evidence provided is
            true and complete in all respects. If there are any false statements
            which are considered perjury, I agree to be subjected to any
            applicable legal prosecution.
          </b>
        </div>
        <ButtonController
          onClickSaveDraft={() => {
            if (!canEdit) {
              dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
              return;
            }
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
